const styles = {
  // --- BUTTONS SETTINGS
  'button': {

    'whiteTheme': {
      'background': {
        'type': 'Normal',
        'gradient': {
          'from': {
            'hex': '#8757f3',
            'rgba': {
              'r': 135,
              'g': 87,
              'b': 243,
              'a': 1
            }
          },
          'to': {
            'hex': '#8757f3',
            'rgba': {
              'r': 135,
              'g': 87,
              'b': 243,
              'a': 1
            }
          }
        }
      },
      'hoverBackground': {
        'type': 'Normal',
        'gradient': {
          'from': {
            'hex': '#000000',
            'rgba': {
              'r': 0,
              'g': 0,
              'b': 0,
              'a': 1
            }
          },
          'to': {
            'hex': '#000000',
            'rgba': {
              'r': 0,
              'g': 0,
              'b': 0,
              'a': 1
            }
          }
        }
      },
      'borderColor': {
        'hex': '#8757f3',
        'rgba': {
          'r': 135,
          'g': 87,
          'b': 243,
          'a': 1
        }
      },
      'hoverBorderColor': {
        'hex': '#8757f3',
        'rgba': {
          'r': 135,
          'g': 87,
          'b': 243,
          'a': 1
        }
      },
      'font': {
        'hoverColor': {
          'hex': '#ffffff',
          'rgba': {
            'r': 255,
            'g': 255,
            'b': 255,
            'a': 1
          }
        },
        'size': 16,
        'family': 'Montserrat',
        'color': {
          'hex': '#ffffff',
          'rgba': {
            'r': 255,
            'g': 255,
            'b': 255,
            'a': 1
          }
        }
      }
    },

    'darkTheme': {
      'background': {
        'type': 'Normal',
        'gradient': {
          'from': {
            'hex': '#8757f3',
            'rgba': {
              'r': 135,
              'g': 87,
              'b': 243,
              'a': 1
            }
          },
          'to': {
            'hex': '#8757f3',
            'rgba': {
              'r': 135,
              'g': 87,
              'b': 243,
              'a': 1
            }
          }
        }
      },
      'hoverBackground': {
        'type': 'Normal',
        'gradient': {
          'from': {
            'hex': '#000000',
            'rgba': {
              'r': 0,
              'g': 0,
              'b': 0,
              'a': 1
            }
          },
          'to': {
            'hex': '#000000',
            'rgba': {
              'r': 0,
              'g': 0,
              'b': 0,
              'a': 1
            }
          }
        }
      },
      'borderColor': {
        'hex': '#ffffff',
        'rgba': {
          'r': 255,
          'g': 255,
          'b': 255,
          'a': 1
        }
      },
      'hoverBorderColor': {
        'hex': '#ffffff',
        'rgba': {
          'r': 255,
          'g': 255,
          'b': 255,
          'a': 1
        }
      },
      'font': {
        'hoverColor': {
          'hex': '#ffffff',
          'rgba': {
            'r': 255,
            'g': 255,
            'b': 255,
            'a': 1
          }
        },
        'size': 16,
        'family': 'Montserrat',
        'color': {
          'hex': '#ffffff',
          'rgba': {
            'r': 255,
            'g': 255,
            'b': 255,
            'a': 1
          }
        }
      }
    },

    'marketingTheme1': {
      'background': {
        'type': 'Normal',
        'gradient': {
          'from': {
            'hex': '#1d70b7',
            'rgba': {
              'r': 29,
              'g': 112,
              'b': 183,
              'a': 1
            }
          },
          'to': {
            'hex': '#1d70b7',
            'rgba': {
              'r': 29,
              'g': 112,
              'b': 183,
              'a': 1
            }
          }
        }
      },
      'hoverBackground': {
        'type': 'Normal',
        'gradient': {
          'from': {
            'hex': '#1d70b7',
            'rgba': {
              'r': 29,
              'g': 112,
              'b': 183,
              'a': 1
            }
          },
          'to': {
            'hex': '#1d70b7',
            'rgba': {
              'r': 29,
              'g': 112,
              'b': 183,
              'a': 1
            }
          }
        }
      },
      'borderColor': {
        'hex': '#ffffff',
        'rgba': {
          'r': 255,
          'g': 255,
          'b': 255,
          'a': 1
        }
      },
      'hoverBorderColor': {
        'hex': '#ffffff',
        'rgba': {
          'r': 255,
          'g': 255,
          'b': 255,
          'a': 1
        }
      },
      'font': {
        'hoverColor': {
          'hex': '#ffffff',
          'rgba': {
            'r': 255,
            'g': 255,
            'b': 255,
            'a': 1
          }
        },
        'size': 16,
        'family': 'Montserrat',
        'color': {
          'hex': '#ffffff',
          'rgba': {
            'r': 255,
            'g': 255,
            'b': 255,
            'a': 1
          }
        }
      }
    },

    'marketingTheme2': {
      'background': {
        'type': 'Gradient',
        'gradient': {
          'from': {
            'hex': '#e23287',
            'rgba': {
              'r': 226,
              'g': 50,
              'b': 135,
              'a': 1
            }
          },
          'to': {
            'hex': '#27a8e0',
            'rgba': {
              'r': 39,
              'g': 168,
              'b': 224,
              'a': 1
            }
          }
        }
      },
      'hoverBackground': {
        'type': 'Gradient',
        'gradient': {
          'from': {
            'hex': '#e23287',
            'rgba': {
              'r': 226,
              'g': 50,
              'b': 135,
              'a': 1
            }
          },
          'to': {
            'hex': '#27a8e0',
            'rgba': {
              'r': 39,
              'g': 168,
              'b': 224,
              'a': 1
            }
          }
        }
      },
      'borderColor': {
        'hex': '#ffffff',
        'rgba': {
          'r': 255,
          'g': 255,
          'b': 255,
          'a': 1
        }
      },
      'hoverBorderColor': {
        'hex': '#ffffff',
        'rgba': {
          'r': 255,
          'g': 255,
          'b': 255,
          'a': 1
        }
      },
      'font': {
        'hoverColor': {
          'hex': '#ffffff',
          'rgba': {
            'r': 255,
            'g': 255,
            'b': 255,
            'a': 1
          }
        },
        'size': 16,
        'family': 'Montserrat',
        'color': {
          'hex': '#ffffff',
          'rgba': {
            'r': 255,
            'g': 255,
            'b': 255,
            'a': 1
          }
        }
      }
    }
  },
  // --- INPUTS SETTINGS
  'input': {
    'whiteTheme': {
      'backgroundColor': {
        'type': 'Normal',
        'gradient': {
          'from': {
            'hex': '#ffffff',
            'rgba': {
              'r': 255,
              'g': 255,
              'b': 255,
              'a': 1
            }
          },
          'to': {
            'hex': '#ffffff',
            'rgba': {
              'r': 255,
              'g': 255,
              'b': 255,
              'a': 1
            }
          }
        }
      },
      'borderColor': {
        'type': 'Normal',
        'gradient': {
          'from': {
            'hex': '#000000',
            'rgba': {
              'r': 0,
              'g': 0,
              'b': 0,
              'a': 1
            }
          },
          'to': {
            'hex': '#000000',
            'rgba': {
              'r': 0,
              'g': 0,
              'b': 0,
              'a': 1
            }
          }
        }
      },
      'iconColor': {
        'hex': '#ffffff',
        'rgba': {
          'r': 255,
          'g': 255,
          'b': 255,
          'a': 1
        }
      },
      'font': {
        'size': 20,
        'family': 'Montserrat',
        'color': {
          'hex': '#000000',
          'rgba': {
            'r': 0,
            'g': 0,
            'b': 0,
            'a': 1
          }
        }
      }
    },
    'darkTheme': {
      'backgroundColor': {
        'type': 'Normal',
        'gradient': {
          'from': {
            'hex': '#ffffff',
            'rgba': {
              'r': 255,
              'g': 255,
              'b': 255,
              'a': 0
            }
          },
          'to': {
            'hex': '#ffffff',
            'rgba': {
              'r': 255,
              'g': 255,
              'b': 255,
              'a': 0
            }
          }
        }
      },
      'borderColor': {
        'type': 'Normal',
        'gradient': {
          'from': {
            'hex': '#ffffff',
            'rgba': {
              'r': 255,
              'g': 255,
              'b': 255,
              'a': 1
            }
          },
          'to': {
            'hex': '#ffffff',
            'rgba': {
              'r': 255,
              'g': 255,
              'b': 255,
              'a': 1
            }
          }
        }
      },
      'iconColor': {
        'hex': '#8757f3',
        'rgba': {
          'r': 135,
          'g': 87,
          'b': 243,
          'a': 1
        }
      },
      'font': {
        'size': 20,
        'family': 'Montserrat',
        'color': {
          'hex': '#ffffff',
          'rgba': {
            'r': 255,
            'g': 255,
            'b': 255,
            'a': 1
          }
        }
      }
    }
  },
  // --- CHECKBOXES SETTINGS
  'checkbox': {
    'background': {
      'type': 'Gradient',
      'gradient': {
        'from': {
          'hex': '#8757f3',
          'rgba': {
            'r': 135,
            'g': 87,
            'b': 243,
            'a': 1
          }
        },
        'to': {
          'hex': '#c86dd7',
          'rgba': {
            'r': 200,
            'g': 109,
            'b': 215,
            'a': 1
          }
        }
      }
    },
    'font': {
      'size': 16,
      'family': 'Montserrat',
      'color': {
        'hex': '#000000',
        'rgba': {
          'r': 0,
          'g': 0,
          'b': 0,
          'a': 1
        }
      }
    }
  },
  // --- RADIOBUTTONS SETTINGS
  'radioButton': {
    'background': {
      'type': 'Gradient',
      'gradient': {
        'from': {
          'hex': '#3023ae',
          'rgba': {
            'r': 48,
            'g': 35,
            'b': 174,
            'a': 1
          }
        },
        'to': {
          'hex': '#c86dd7',
          'rgba': {
            'r': 200,
            'g': 109,
            'b': 215,
            'a': 1
          }
        }
      }
    },
    'font': {
      'size': 16,
      'family': 'Montserrat',
      'color': {
        'hex': '#000000',
        'rgba': {
          'r': 0,
          'g': 0,
          'b': 0,
          'a': 1
        }
      }
    }
  },
  // --- WEBPORTAL FOOTER SETTINGS
  'footer': {
    'logoImage': 'https://res.cloudinary.com/dwfqtxxpx/image/upload/v1548343515/nudy0eizvwqtj3p5kz7s.png',
    'background': {
      'type': 'Normal',
      'gradient': {
        'from': {
          'hex': '#484848',
          'rgba': {
            'r': 72,
            'g': 72,
            'b': 72,
            'a': 1
          }
        },
        'to': {
          'hex': '#484848',
          'rgba': {
            'r': 72,
            'g': 72,
            'b': 72,
            'a': 1
          }
        }
      }
    },
    'regularTextFont': {
      'size': 14,
      'family': 'Montserrat',
      'color': {
        'hex': '#e9e9e9',
        'rgba': {
          'r': 233,
          'g': 233,
          'b': 233,
          'a': 1
        }
      }
    },
    'linksFont': {
      'hoverColor': {
        'hex': '#e9e9e9',
        'rgba': {
          'r': 233,
          'g': 233,
          'b': 233,
          'a': 1
        }
      },
      'size': 16,
      'family': 'Montserrat',
      'color': {
        'hex': '#e9e9e9',
        'rgba': {
          'r': 233,
          'g': 233,
          'b': 233,
          'a': 1
        }
      }
    }
  },
  // --- HEADER SETTINGS
  'header': {
    'logoImage': 'https://res.cloudinary.com/dwfqtxxpx/image/upload/v1548342893/m5mg6ehpbabkaikligjw.png',
    'background': {
      'hex': '#221e20',
      'rgba': {
        'r': 34,
        'g': 30,
        'b': 32,
        'a': 1
      }
    },
    'linksFont': {
      'hoverColor': {
        'hex': '#e83284',
        'rgba': {
          'r': 232,
          'g': 50,
          'b': 132,
          'a': 1
        }
      },
      'size': 16,
      'family': 'Montserrat',
      'color': {
        'hex': '#ffffff',
        'rgba': {
          'r': 255,
          'g': 255,
          'b': 255,
          'a': 1
        }
      }
    }
  },
  // U --- CONTENT TEXT SETTINGS - U
  'contentText': {
    'iconColor': {
      'hex': '#B34242',
      'rgba': {
        'r': 179,
        'g': 66,
        'b': 66,
        'a': 1
      }
    },
    'font': {
      'size': 17,
      'family': 'Libre Franklin',
      'color': {
        'hex': '#B95959',
        'rgba': {
          'r': 185,
          'g': 89,
          'b': 89,
          'a': 1
        }
      }
    }
  },
  // --- DECORATIVE ELEMENTS SETTINGS
  'decorativeElement': {
    'primaryAccentBackground': {
      'type': 'Gradient',
      'gradient': {
        'from': {
          'hex': '#3423a8',
          'rgba': {
            'r': 52,
            'g': 35,
            'b': 168,
            'a': 1
          }
        },
        'to': {
          'hex': '#c368cf',
          'rgba': {
            'r': 195,
            'g': 104,
            'b': 207,
            'a': 1
          }
        }
      }
    },
    'secondAccentBackground': {
      'type': 'Gradient',
      'gradient': {
        'from': {
          'hex': '#e23287',
          'rgba': {
            'r': 226,
            'g': 50,
            'b': 135,
            'a': 1
          }
        },
        'to': {
          'hex': '#27a8e0',
          'rgba': {
            'r': 39,
            'g': 168,
            'b': 224,
            'a': 1
          }
        }
      }
    },
    'thirdAccentBackground': {
      'type': 'Normal',
      'gradient': {
        'from': {
          'hex': '#e0e0e0',
          'rgba': {
            'r': 224,
            'g': 224,
            'b': 224,
            'a': 1
          }
        },
        'to': {
          'hex': '#e0e0e0',
          'rgba': {
            'r': 224,
            'g': 224,
            'b': 224,
            'a': 1
          }
        }
      }
    },
    'primarySeparatorColor': {
      'hex': '#8a8a8a',
      'rgba': {
        'r': 138,
        'g': 138,
        'b': 138,
        'a': 1
      }
    },
    'secondSeparatorColor': {
      'hex': '#000000',
      'rgba': {
        'r': 0,
        'g': 0,
        'b': 0,
        'a': 1
      }
    },
    'primaryAccentColor': {
      'hex': '#8757f3',
      'rgba': {
        'r': 135,
        'g': 87,
        'b': 243,
        'a': 1
      }
    },
    'secondAccentColor': {
      'hex': '#245f93',
      'rgba': {
        'r': 36,
        'g': 95,
        'b': 147,
        'a': 1
      }
    },
    'thirdAccentColor': {
      'hex': '#f9da1b',
      'rgba': {
        'r': 249,
        'g': 218,
        'b': 27,
        'a': 1
      }
    },
    'fourthAccentColor': {
      'hex': '#ffc439',
      'rgba': {
        'r': 255,
        'g': 196,
        'b': 57,
        'a': 1
      }
    },
    'fifthAccentColor': {
      'hex': '#5563a9',
      'rgba': {
        'r': 85,
        'g': 99,
        'b': 169,
        'a': 1
      }
    }
  },
  // --- ERROR MESSAGES SETTINGS
  'error': {
    'whiteTheme': {
      'textColor': {
        'hex': '#e83284',
        'rgba': {
          'r': 232,
          'g': 50,
          'b': 132,
          'a': 1
        }
      }
    },
    'darkTheme': {
      'textColor': {
        'hex': '#f8e71c',
        'rgba': {
          'r': 248,
          'g': 231,
          'b': 28,
          'a': 1
        }
      }
    }
  },
  // --- WEBPORTAL MAIN HEADER SETTINGS
  'pageHeaderHeight': {
    'about': 290,
    'venue': 600,
    'agenda': 100,
    'speakers': 190,
    'sponsors': 150,
    'attendees': 190,
    'crypto': 360,
    'home': 520
  },
  // U --- PAGE HEADINGS SETTINGS - U
  'heading': {
    'h1': {
      'size': 14,
      'family': 'Arial Black',
      'color': {
        'hex': '#934545',
        'rgba': {
          'r': 147,
          'g': 69,
          'b': 69,
          'a': 1
        }
      }
    },
    'h2': {
      'size': 14,
      'family': 'Arial Black',
      'color': {
        'hex': '#DD8D8D',
        'rgba': {
          'r': 221,
          'g': 141,
          'b': 141,
          'a': 1
        }
      }
    },
    'h3': {
      'size': 13,
      'family': 'Arial Black',
      'color': {
        'hex': '#E96E6E',
        'rgba': {
          'r': 233,
          'g': 110,
          'b': 110,
          'a': 1
        }
      }
    },
    'h4': {
      'size': 14,
      'family': 'Arial Black',
      'color': {
        'hex': '#866464',
        'rgba': {
          'r': 134,
          'g': 100,
          'b': 100,
          'a': 1
        }
      }
    }
  },
  // --- CONTENT LINKS SETTINGS
  'link': {
    'font': {
      'hoverColor': {
        'hex': '#006fb3',
        'rgba': {
          'r': 0,
          'g': 111,
          'b': 179,
          'a': 1
        }
      },
      'size': 16,
      'family': 'Montserrat',
      'color': {
        'hex': '#000000',
        'rgba': {
          'r': 0,
          'g': 0,
          'b': 0,
          'a': 1
        }
      }
    },
    'textDecoration': 'none'
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/utils/defaultGlobalStyleSettings.js